export default __webpack_public_path__ + "static/media/17.9cbe1dc3.png";